function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import withStyles from 'isomorphic-style-loader/withStyles';
import { isAggregatedPreMeal } from 'libs/StatsCalculations';
import App from 'modules/App';
import { getFromGlucoseLevelDistribution, getFromReadings } from './helpers';
import styles from './GlucoseLevelDistributionChart.pcss';
const ResponsivePie = /*#__PURE__*/ lazy(()=>import('@nivo/pie').then((m)=>({
            default: m.ResponsivePie
        })));
var _React_PureComponent;
class GlucoseLevelDistributionChart extends (_React_PureComponent = React.PureComponent) {
    static getDerivedStateFromProps(props, state) {
        const { glucoseLevelDistribution, standards, readings, valueKey } = props;
        if (glucoseLevelDistribution && glucoseLevelDistribution !== state.glucoseLevelDistribution) {
            return getFromGlucoseLevelDistribution(glucoseLevelDistribution);
        }
        if (readings && readings !== state.readings) {
            return getFromReadings(readings, valueKey, standards);
        }
        return null;
    }
    get loaderMockValues() {
        return [
            {
                id: 'high',
                label: 'high',
                value: 1
            },
            {
                id: 'target',
                label: 'target',
                value: 1
            },
            {
                id: 'low',
                label: 'low',
                value: 1
            }
        ];
    }
    get isFlagFilters() {
        const { flagFilters } = this.props;
        const isNoFilters = isEmpty(flagFilters);
        let isPreMealFilter = isNoFilters;
        let isPostMealFilter = isNoFilters;
        let i = 0;
        while((!isPreMealFilter || !isPostMealFilter) && i < flagFilters.length){
            if (isAggregatedPreMeal(flagFilters[i])) {
                isPreMealFilter = true;
            } else {
                isPostMealFilter = true;
            }
            i++;
        }
        return {
            isPreMealFilter,
            isPostMealFilter
        };
    }
    renderLegendSubItem(type, isPostMeal, isPreMealFilter, isPostMealFilter) {
        if (isPostMeal && !isPostMealFilter || !isPostMeal && !isPreMealFilter) {
            return null;
        }
        const { preMealSum, postMealSum, levels } = this.state;
        const sum = isPostMeal ? postMealSum : preMealSum;
        const level = get(levels, [
            isPostMeal ? 'postMeal' : 'preMeal',
            type
        ]);
        const flag = isPostMeal ? 'PostMeal' : 'PreMeal';
        const colNumber = isPostMeal && !isPreMealFilter || !isPostMeal && !isPostMealFilter ? 12 : 6;
        return /*#__PURE__*/ _jsxs("div", {
            className: `col-${colNumber}`,
            children: [
                /*#__PURE__*/ _jsx("span", {
                    className: cn('legend__item__disc', `legend__item__disc--${type}`, {
                        'legend__item__disc--double-color': isPostMeal
                    })
                }),
                /*#__PURE__*/ _jsxs("p", {
                    className: "text--large text--bold",
                    children: [
                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.flags[flag])),
                        ' ',
                        "(",
                        sum && Math.round(level / sum * 100),
                        "%)"
                    ]
                })
            ]
        });
    }
    renderLegendItem(type, isPreMealFilter, isPostMealFilter) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "legend__item",
            children: [
                /*#__PURE__*/ _jsx("h5", {
                    className: styles.glucoseLevel__header,
                    children: /*#__PURE__*/ _jsx("span", {
                        className: "text--large text--bold",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.levels[type]))
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "row",
                    children: [
                        this.renderLegendSubItem(type, false, isPreMealFilter, isPostMealFilter),
                        this.renderLegendSubItem(type, true, isPreMealFilter, isPostMealFilter)
                    ]
                })
            ]
        });
    }
    renderLegend(isPreMealFilter, isPostMealFilter) {
        return /*#__PURE__*/ _jsx("div", {
            className: "legend",
            children: /*#__PURE__*/ _jsxs("ul", {
                className: "list--unstyled row",
                children: [
                    /*#__PURE__*/ _jsx("li", {
                        className: "col-4",
                        children: this.renderLegendItem('low', isPreMealFilter, isPostMealFilter)
                    }),
                    /*#__PURE__*/ _jsx("li", {
                        className: "col-4",
                        children: this.renderLegendItem('target', isPreMealFilter, isPostMealFilter)
                    }),
                    /*#__PURE__*/ _jsx("li", {
                        className: "col-4",
                        children: this.renderLegendItem('high', isPreMealFilter, isPostMealFilter)
                    })
                ]
            })
        });
    }
    renderVerticalLegendSubItem(type, isPostMeal) {
        const { preMealSum, postMealSum, levels } = this.state;
        const { standards, conversion } = this.props;
        const sum = isPostMeal ? postMealSum : preMealSum;
        const level = get(levels, [
            isPostMeal ? 'postMeal' : 'preMeal',
            type
        ]);
        const mode = isPostMeal ? 'postMeal' : 'preMeal';
        let thresholdLabel;
        switch(type){
            case 'low':
                {
                    thresholdLabel = `< ${conversion.toDisplay(standards[mode].lowThreshold)} ${conversion.unitSymbol}`;
                    break;
                }
            case 'high':
                {
                    thresholdLabel = `> ${conversion.toDisplay(standards[mode].highThreshold)} ${conversion.unitSymbol}`;
                    break;
                }
            case 'target':
                {
                    thresholdLabel = `${conversion.toDisplay(standards[mode].lowThreshold)} - ${conversion.toDisplay(standards[mode].highThreshold)} ${conversion.unitSymbol}`;
                    break;
                }
            default:
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: "col",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "legend__item__pad",
                    children: /*#__PURE__*/ _jsx("span", {
                        className: cn('legend__item__rect', `legend__item__rect--${type}`, {
                            'legend__item__rect--double-color': isPostMeal
                        })
                    })
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "text--large text--bold",
                    children: /*#__PURE__*/ _jsxs("span", {
                        className: "text--large text--bold",
                        children: [
                            /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.levels[type])),
                            " (",
                            sum && Math.round(level / sum * 100),
                            "%)"
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "text--gray mt-2",
                    children: thresholdLabel
                })
            ]
        });
    }
    renderVerticalLegendItem(type, isPostMeal = false) {
        return /*#__PURE__*/ _jsx("div", {
            className: "legend__item",
            children: /*#__PURE__*/ _jsx("div", {
                className: "row",
                children: this.renderVerticalLegendSubItem(type, isPostMeal)
            })
        });
    }
    renderVerticalLegend(isPreMealFilter, isPostMealFilter) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "mt-3",
            children: [
                isPreMealFilter && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx("h5", {
                            className: styles.glucoseLevel__verticalHeader,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.flags.PreMeal))
                        }),
                        /*#__PURE__*/ _jsxs("ul", {
                            className: "list--unstyled row",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "col-4",
                                    children: this.renderVerticalLegendItem('target')
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "col-4",
                                    children: this.renderVerticalLegendItem('low')
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "col-4",
                                    children: this.renderVerticalLegendItem('high')
                                })
                            ]
                        })
                    ]
                }),
                isPreMealFilter && isPostMealFilter && /*#__PURE__*/ _jsx("div", {
                    className: styles.glucoseLevel__verticalHeader__hr
                }),
                isPostMealFilter && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx("h5", {
                            className: styles.glucoseLevel__verticalHeader,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.flags.PostMeal))
                        }),
                        /*#__PURE__*/ _jsxs("ul", {
                            className: "list--unstyled row",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "col-4",
                                    children: this.renderVerticalLegendItem('target', true)
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "col-4",
                                    children: this.renderVerticalLegendItem('low', true)
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "col-4",
                                    children: this.renderVerticalLegendItem('high', true)
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    renderBackgroundChart(sharedProps, isOnlyOneChart) {
        if (!process.env.BROWSER) {
            return null;
        }
        return /*#__PURE__*/ _jsx("div", {
            className: "nivoPieChartBackground",
            children: /*#__PURE__*/ _jsx(Suspense, {
                fallback: null,
                children: /*#__PURE__*/ _jsx(ResponsivePie, _object_spread_props(_object_spread({}, sharedProps), {
                    data: [
                        {
                            id: 'background',
                            value: 1,
                            label: 'background'
                        }
                    ],
                    colors: [
                        '#F5F9FF'
                    ],
                    innerRadius: isOnlyOneChart ? 0.8 : 0.55,
                    borderWidth: 30
                }))
            })
        });
    }
    renderPreMealChart(sharedProps, chartColors, isInProgress) {
        if (!process.env.BROWSER) {
            return null;
        }
        const { preMeal } = this.state;
        return /*#__PURE__*/ _jsx("div", {
            className: "nivoChart__inner nivoPieChart",
            children: /*#__PURE__*/ _jsx(Suspense, {
                fallback: null,
                children: /*#__PURE__*/ _jsx(ResponsivePie, _object_spread_props(_object_spread({}, sharedProps), {
                    data: isInProgress ? this.loaderMockValues : preMeal,
                    colors: chartColors,
                    innerRadius: 0.8,
                    borderWidth: 0
                }))
            })
        });
    }
    renderPostMealChart(sharedProps, chartColors, isOnlyPostMealFilter, isInProgress) {
        if (!process.env.BROWSER) {
            return null;
        }
        const { postMeal } = this.state;
        const margin = isOnlyPostMealFilter ? sharedProps.margin : {
            top: 65,
            right: 65,
            bottom: 65,
            left: 65
        };
        return /*#__PURE__*/ _jsx("div", {
            className: "nivoChart__inner nivoPieChart",
            children: /*#__PURE__*/ _jsx(Suspense, {
                fallback: null,
                children: /*#__PURE__*/ _jsx(ResponsivePie, _object_spread_props(_object_spread({}, sharedProps), {
                    data: isInProgress ? this.loaderMockValues : postMeal,
                    colors: chartColors,
                    margin: margin,
                    innerRadius: isOnlyPostMealFilter ? 0.8 : 0.75,
                    borderWidth: 0,
                    defs: [
                        {
                            id: 'lines',
                            type: 'patternLines',
                            background: 'inherit',
                            color: 'rgba(255, 255, 255, 0.3)',
                            rotation: -45,
                            lineWidth: 6,
                            spacing: 10
                        }
                    ],
                    fill: [
                        {
                            match: '*',
                            id: 'lines'
                        }
                    ]
                }))
            })
        });
    }
    render() {
        const { isInProgress } = this.props;
        const { isPreMealFilter, isPostMealFilter } = this.isFlagFilters;
        const isOnlyPreMealFilter = isPreMealFilter && !isPostMealFilter;
        const isOnlyPostMealFilter = isPostMealFilter && !isPreMealFilter;
        const isOnlyOneChart = isOnlyPreMealFilter || isOnlyPostMealFilter;
        const sharedProps = {
            margin: {
                top: 40,
                right: 40,
                bottom: 40,
                left: 40
            },
            borderColor: {
                from: 'color'
            },
            enableArcLabels: false,
            enableArcLinkLabels: false,
            animate: true,
            isInteractive: false
        };
        const chartColors = isInProgress ? [
            '#E0E8F2',
            '#E0E8F2',
            '#E0E8F2'
        ] : [
            '#F4C32C',
            '#1EA98C',
            '#F74053'
        ];
        return /*#__PURE__*/ _jsxs("div", {
            className: cn('chartContainer', {
                'chartContainer--in-progress': isInProgress
            }),
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "nivoChart nivoPieChartBackground",
                    children: [
                        this.renderBackgroundChart(sharedProps, isOnlyOneChart),
                        isPreMealFilter && this.renderPreMealChart(sharedProps, chartColors, isInProgress),
                        isPostMealFilter && this.renderPostMealChart(sharedProps, chartColors, isOnlyPostMealFilter, isInProgress)
                    ]
                }),
                this.props.verticalLegend ? this.renderVerticalLegend(isPreMealFilter, isPostMealFilter) : this.renderLegend(isPreMealFilter, isPostMealFilter)
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            preMeal: [],
            postMeal: [],
            preMealSum: 0,
            postMealSum: 0,
            levels: {
                preMeal: {
                    high: 0,
                    target: 0,
                    low: 0
                },
                postMeal: {
                    high: 0,
                    target: 0,
                    low: 0
                }
            },
            glucoseLevelDistribution: null,
            readings: []
        };
    }
}
_define_property(GlucoseLevelDistributionChart, "propTypes", {
    // Explicit props
    readings: PropTypes.array,
    glucoseLevelDistribution: PropTypes.shape({
        highPostMeal: PropTypes.number,
        highPreMeal: PropTypes.number,
        lowPostMeal: PropTypes.number,
        lowPreMeal: PropTypes.number,
        targetPostMeal: PropTypes.number,
        targetPreMeal: PropTypes.number
    }),
    flagFilters: PropTypes.arrayOf(PropTypes.oneOf([
        'Fasting',
        'PreMeal',
        'PostMeal',
        'None'
    ])),
    standards: PropTypes.shape({
        maxValue: PropTypes.number.isRequired,
        preMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        }),
        postMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        })
    }),
    conversion: PropTypes.object,
    valueKey: PropTypes.string.isRequired,
    isInProgress: PropTypes.bool,
    verticalLegend: PropTypes.bool
});
export default withStyles(styles)(GlucoseLevelDistributionChart);
